/** Build + trigger a CSV download entirely client-side (spec §16: static, no backend). */
export function downloadCsv(filename: string, rows: string[][]): void {
  const esc = (v: string) => (/[",\n]/.test(v) ? `"${v.replace(/"/g, '""')}"` : v);
  const csv = rows.map((r) => r.map(esc).join(',')).join('\n') + '\n';
  const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export const MILEAGE_LOG: Record<'en' | 'es', string[][]> = {
  en: [
    ['Date', 'Start odometer', 'End odometer', 'Miles', 'Purpose (run / zone)', 'Notes'],
    ['2026-01-05', '41200', '41238', '38', 'Plaza Midwood run · 3 stops', ''],
    ['', '', '', '', '', 'Log every delivery mile the day you drive it. Personal miles do not count.'],
  ],
  es: [
    ['Fecha', 'Odómetro inicial', 'Odómetro final', 'Millas', 'Propósito (ruta / zona)', 'Notas'],
    ['2026-01-05', '41200', '41238', '38', 'Ruta Plaza Midwood · 3 paradas', ''],
    ['', '', '', '', '', 'Anota cada milla de entrega el mismo día. Las millas personales no cuentan.'],
  ],
};

export const EXPENSE_TRACKER: Record<'en' | 'es', string[][]> = {
  en: [
    ['Date', 'Vendor', 'Category (Schedule C line)', 'Amount', 'Paid with', 'Receipt kept? (Y/N)', 'Notes'],
    ['2026-01-05', 'Store', 'Supplies (insulated bags, coolers)', '42.10', 'Business debit', 'Y', ''],
    ['2026-01-06', 'City parking', 'Parking & tolls', '3.00', 'Business debit', 'Y', ''],
    ['', '', 'Phone (business-use %)', '', '', '', 'Only the share you use for deliveries.'],
  ],
  es: [
    ['Fecha', 'Proveedor', 'Categoría (línea del Anexo C)', 'Monto', 'Pagado con', '¿Recibo guardado? (S/N)', 'Notas'],
    ['2026-01-05', 'Tienda', 'Suministros (bolsas térmicas, hieleras)', '42.10', 'Débito del negocio', 'S', ''],
    ['2026-01-06', 'Estacionamiento', 'Estacionamiento y peajes', '3.00', 'Débito del negocio', 'S', ''],
    ['', '', 'Teléfono (% de uso para el negocio)', '', '', '', 'Solo la parte que usas para entregas.'],
  ],
};
